import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BillerLookupComponent } from './biller.lookup.component';
import { BillerService }         from './biller.service';
import { SharedModule }          from '../shared/shared.module';
import { TableModule }           from '../table/table.module';

@NgModule({
  declarations: [
    BillerLookupComponent
  ],
  entryComponents: [
    BillerLookupComponent
  ],
  exports: [
    BillerLookupComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    BillerService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BillerModule {}